export default "__VITE_ASSET__zQdkZiNt__"